/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageViewerComponent } from '@app/components/image-viewer/image-viewer.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [ImageViewerComponent],
  exports: [ImageViewerComponent],
  imports: [CommonModule, MatProgressBarModule],
})
export class ImageViewerModule {}
